/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_ActivationInputs */



/**
* | output |
* | --- |
* | "Offline Activation" |
*
* @param {Offline_ActivationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_activation = /** @type {((inputs?: Offline_ActivationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_ActivationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Activation hors ligne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Offline-Aktivierung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attivazione offline")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автономная активация")
	if (locale === "es") return /** @type {LocalizedString} */ ("Activación sin conexión")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("离线激活")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オフラインアクティベーション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑफ़लाइन सक्रियण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ativação offline")
	return /** @type {LocalizedString} */ ("Offline Activation")
});